/**
 * Two-tier ground dims from facility slab bounds.
 * @param {{col,row,w,h}} slab
 * @param {number} tileSize
 * @param {number} outerExtend - tiles beyond slab for outer apron
 * @param {number} innerInset - tiles the inner pad sits inside the outer edge
 */
export function groundTiers(slab, tileSize, outerExtend = 5, innerInset = 1.5) {
  const centerX = (slab.col + slab.w / 2) * tileSize;
  const centerZ = (slab.row + slab.h / 2) * tileSize;
  const outerW = (slab.w + outerExtend * 2) * tileSize;
  const outerD = (slab.h + outerExtend * 2) * tileSize;
  const innerW = Math.max(tileSize, outerW - innerInset * 2 * tileSize);
  const innerD = Math.max(tileSize, outerD - innerInset * 2 * tileSize);
  return {
    centerX,
    centerZ,
    outer: { x: centerX, z: centerZ, w: outerW, d: outerD },
    inner: { x: centerX, z: centerZ, w: innerW, d: innerD },
  };
}

/**
 * Stylized panel seam offsets in local ground space (y-up world; seams on XZ).
 * @returns {{axis:'x'|'z', offset:number}[]}
 */
export function groundSeamOffsets(padW, padD, divisions = 4) {
  const seams = [];
  for (let i = 1; i < divisions; i++) {
    const t = i / divisions - 0.5;
    seams.push({ axis: 'x', offset: t * padW });
    seams.push({ axis: 'z', offset: t * padD });
  }
  return seams;
}
